import { put, all, call, takeEvery } from "redux-saga/effects"
import { promptRegisterPendingReview, reportRegisterFailure, startUserRegister, UserRegisterAction, USER_REGISTER } from "~/actions/register"
import { RegisterResultResponseDto, RegisterResult } from "~/gen/api/user"
import { userApiClient } from "~/lib/client"
import { push } from "connected-react-router";
import { executeRecaptcha } from "./recaptcha";
import { AxiosResponse } from "axios";
import retrieveAxiosErr from "~/utils/retrieveAxiosErr";


export default function* registrationEffects() {
  yield all([
    takeEvery(USER_REGISTER, handleRegister),
  ])
}

function* handleRegister(action: UserRegisterAction): any {
  const { payload } = action

  yield put(startUserRegister(payload.email))

  let result : AxiosResponse<RegisterResultResponseDto> | null = null
  try
  {
    const recaptchaResponse: string = yield call(executeRecaptcha, 'register')

    //@ts-ignore
    result = yield call([userApiClient, 'apiUsersRegisterPost'], { ...payload, recaptchaResponse })
    
    if (result?.data.result === RegisterResult.Success) {
      yield put(promptRegisterPendingReview(result.data.email || ''))
      yield put(push('/register-success'))
    } else {
      const domainExists = result?.data.result === RegisterResult.DomainExists
      yield put(reportRegisterFailure(result?.data.resultText || '', domainExists))
      if (domainExists) {
        yield put(push('/register-domain-exists'))
      }
    } 
  }
  catch(err) {
    let errMsg = retrieveAxiosErr(err)

    yield put(reportRegisterFailure(errMsg))
  }
}

